import { FC } from 'react';
import classnames from 'classnames';

import { useIsRabotaBy } from 'src/hooks/useSite';
import { useSelector } from 'src/modules/useSelector';

import styles from 'src/components/LogoPrint/logo-print.less';

const LogoPrint: FC = () => {
    const host = useSelector((state) => state.request.host);
    const staticHost = useSelector((state) => state.config.staticHost);

    const isRabotaBy = useIsRabotaBy();

    const src = isRabotaBy ? 'logo.rabota.by.svg' : 'logo.svg';

    return (
        <img
            className={classnames(styles.logoPrint, isRabotaBy && styles.logoPrintBy)}
            src={`${staticHost || ''}/static/files/images/${src}`}
            alt={host}
        />
    );
};

export default LogoPrint;
